import { api } from '../axiosClient';
import { PROJECT_EXPENSES_BASE_PATH } from './constants';
import type {
  CreateProjectExpensePayload,
  PatchProjectExpensePayload,
  RESTProjectExpense,
} from './projectExpenses.types';

export const getProjectExpense = (id: number): Promise<RESTProjectExpense> => {
  return api.get(`${PROJECT_EXPENSES_BASE_PATH}/${id}`);
};

export const postProjectExpense = (
  data: CreateProjectExpensePayload,
): Promise<RESTProjectExpense & { expenseId: number }> => {
  return api.post(`${PROJECT_EXPENSES_BASE_PATH}`, data);
};

export const patchProjectExpense = (
  id: number,
  data: PatchProjectExpensePayload,
): Promise<RESTProjectExpense & { expenseId: number }> => {
  return api.patch(`${PROJECT_EXPENSES_BASE_PATH}/${id}`, data);
};

export const deleteProjectExpense = (id: number): Promise<void> => {
  return api.delete(`${PROJECT_EXPENSES_BASE_PATH}/${id}`);
};
